/* ks-local-hub.js — time-dependent parts of sections/ks-local-hub.liquid:
   status pills + countdown, hero chip status, next weekly cut-off, two-week calendar, shelf reveal.
   All dates are evaluated in America/Los_Angeles. No network calls. */
(function () {
  'use strict';
  var TZ = 'America/Los_Angeles';
  var DOW = ['日', '一', '二', '三', '四', '五', '六'];
  var fmtKey = new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' });
  var fmtHM = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, hour: '2-digit', minute: '2-digit', hour12: false });

  function keyOf(ms) { return fmtKey.format(new Date(ms)); }               // 'YYYY-MM-DD' in PT
  function utcOfKey(k) { var p = k.split('-'); return Date.UTC(+p[0], +p[1] - 1, +p[2]); }
  function keyOfUtc(u) { return new Date(u).toISOString().slice(0, 10); }
  function md(k) { var p = k.split('-'); return (+p[1]) + '/' + (+p[2]); }
  function dowOf(k) { return new Date(utcOfKey(k)).getUTCDay(); }
  function addDays(k, n) { return keyOfUtc(utcOfKey(k) + n * 864e5); }
  function parseAt(s) { if (!s) return NaN; var t = Date.parse(s); return t; }
  function dateKey(s) { if (!s) return ''; if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s; var t = parseAt(s); return isNaN(t) ? '' : keyOf(t); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function cdText(ms) {
    if (ms <= 0) return '';
    var s = Math.floor(ms / 1000), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), x = s % 60;
    return (d ? d + ' 天 ' : '') + pad(h) + ':' + pad(m) + ':' + pad(x);
  }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function dropState(m, now) {
    var o = parseAt(m.openAt), c = parseAt(m.closeAt);
    if (!isNaN(o) && now < o) return 'before';
    if (isNaN(c) || now <= c) return 'open';
    return 'after';
  }
  // next weekly cut-off (date key) at/after now, PT
  function nextCut(m, now) {
    var dow = parseInt(m.cutDow, 10); if (isNaN(dow)) return '';
    var today = keyOf(now), hm = fmtHM.format(new Date(now)), cutHM = (m.cutTime || '12:00');
    for (var i = 0; i < 8; i++) {
      var k = addDays(today, i);
      if (dowOf(k) !== dow) continue;
      if (i === 0 && hm >= cutHM) continue;
      return k;
    }
    return '';
  }

  function init(root) {
    var jsonEl = root.querySelector('[data-kslh-json]');
    var M = [];
    try { M = JSON.parse(jsonEl.textContent); } catch (e) { M = []; }
    root.classList.add('js');

    function paint() {
      var now = Date.now();
      M.forEach(function (m) {
        var pill = root.querySelector('[data-pill="' + m.id + '"]');
        var chip = root.querySelector('[data-chip-status="' + m.id + '"]');
        var cut = root.querySelector('[data-next-cut="' + m.id + '"]');
        var notify = root.querySelector('[data-notify-for="' + m.id + '"]');
        var chipText = m.statusText || '', chipOn = false;
        if (m.status === 'next') {
          var st = dropState(m, now);
          if (pill) {
            if (st === 'before') {
              pill.className = 'kslh-pill next';
              pill.innerHTML = esc(m.statusText) + ' <span class="cd">' + cdText(parseAt(m.openAt) - now) + '</span>';
            } else if (st === 'open') {
              pill.className = 'kslh-pill live';
              pill.textContent = '開團中' + (m.closeAt ? '・' + md(dateKey(m.closeAt)) + ' 截團' : '');
            } else { pill.className = 'kslh-pill weekly'; pill.textContent = '本團已截止'; }
          }
          if (notify) notify.hidden = st !== 'before';
          chipText = st === 'before' ? (m.openAt ? md(dateKey(m.openAt)) + ' 開團' : m.statusText) : (st === 'open' ? '開團中' : '已截止');
          chipOn = st === 'open';
        } else if (m.status === 'live') {
          chipText = '開團中'; chipOn = true;
        } else {
          var k = nextCut(m, now);
          if (k) {
            chipText = md(k) + '（' + DOW[dowOf(k)] + '）截單';
            if (cut) cut.textContent = '・下次 ' + md(k) + '（' + DOW[dowOf(k)] + '）';
          }
        }
        if (chip) { chip.textContent = chipText; chip.classList.toggle('on', chipOn); }
      });
    }
    paint();
    setInterval(paint, 1000);

    var cal = root.querySelector('[data-kslh-cal]');
    if (cal) cal.innerHTML = buildCalendar(M, Date.now());

    var shops = root.querySelectorAll('.kslh-shop');
    var rm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if ('IntersectionObserver' in window && !rm) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      [].forEach.call(shops, function (s) { io.observe(s); });
      // safety net: never leave a shelf invisible (fast scroll, anchor jumps, observer quirks)
      setTimeout(function () { [].forEach.call(shops, function (s) { s.classList.add('in'); }); }, 2000);
    } else { [].forEach.call(shops, function (s) { s.classList.add('in'); }); }
  }

  /* Calendar: Sunday of this week → Saturday of next week (PT). Solid = 截單/截團, dashed = 開團/出貨.
     Events outside the window from live/next merchants go into the 「之後」 line. */
  function buildCalendar(M, now) {
    var today = keyOf(now), start = addDays(today, -dowOf(today)), end = addDays(start, 13);
    var EV = {}, later = [];
    function add(k, m, label, outline) {
      if (!k) return;
      if (k >= start && k <= end) (EV[k] = EV[k] || []).push({ m: m, label: label, o: outline });
      else if (k > end) later.push({ k: k, when: md(k), who: m.cal, label: label });
    }
    M.forEach(function (m) {
      if (m.status === 'weekly') {
        var dow = parseInt(m.cutDow, 10), sdow = parseInt(m.shipDow, 10);
        if (isNaN(dow)) return;
        for (var k = start; k <= end; k = addDays(k, 1)) {
          if (dowOf(k) !== dow) continue;
          add(k, m, '截單', false);
          if (!isNaN(sdow)) { var s = addDays(k, 1); while (dowOf(s) !== sdow) s = addDays(s, 1); if (s <= end) add(s, m, m.shipLabel || '出貨', true); }
        }
      } else {
        if (m.status === 'next') add(dateKey(m.openAt), m, '開團', true);
        add(dateKey(m.closeAt), m, m.status === 'next' ? '截團' : '截單', false);
        var f = dateKey(m.shipFrom), t = dateKey(m.shipTo) || f;
        if (f) {
          if (f > end) later.push({ k: f, when: (t !== f ? md(f) + '–' + md(t) : md(f)), who: m.cal, label: '出貨' });
          else for (var d = f; d <= t && d <= end; d = addDays(d, 1)) add(d, m, '出貨', true);
        }
      }
    });
    var h = '<div class="dow">' + DOW.map(function (d) { return '<span>' + d + '</span>'; }).join('') + '</div>';
    for (var w = 0; w < 2; w++) {
      h += '<div class="wkl">' + (w ? '下週' : '本週') + '</div><div class="wk">';
      for (var i = 0; i < 7; i++) {
        var k = addDays(start, w * 7 + i), cls = k === today ? ' today' : (k < today ? ' past' : '');
        var num = (i === 0 || k.slice(8) === '01') ? md(k) : String(+k.slice(8));
        h += '<div class="day' + cls + '"><span class="n">' + num + '</span>' + (EV[k] || []).map(function (e) {
          var c = esc(e.m.color || '#6E5F55');
          return '<span class="ev' + (e.o ? ' o' : '') + '" style="' + (e.o ? 'color:' + c : 'background:' + c) + '">' + esc(e.m.cal) + '<br>' + esc(e.label) + '</span>';
        }).join('') + '</div>';
      }
      h += '</div>';
    }
    h += '<div class="legend"><span><i style="background:#6E5F55"></i>截單／截團</span><span><i style="border:1.2px dashed #6E5F55"></i>開團／出貨</span></div>';
    if (later.length) {
      later.sort(function (a, b) { return a.k < b.k ? -1 : 1; });
      var grouped = [], idx = {};   // same date + same action → 「11/2–11/3 Ding!、張先生 出貨」
      later.forEach(function (x) { var g = x.when + '|' + x.label; if (idx[g] == null) { idx[g] = grouped.length; grouped.push({ when: x.when, who: [x.who], label: x.label }); } else grouped[idx[g]].who.push(x.who); });
      h += '<p class="later"><b>之後：</b>' + grouped.slice(0, 6).map(function (x) { return esc(x.when + ' ' + x.who.join('、') + ' ' + x.label); }).join('・') + '</p>';
    }
    return h;
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-kslh]'), function (r) { if (!r.__kslh) { r.__kslh = 1; init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
